import types from 'redux/types';
import { checkTypeValue } from 'helpers';

import { changeFilter, setDefaultFilter } from 'redux/stateCase';
import CampaignModel from 'models/campaign.model';

const initialState = {
  filterCampaign: CampaignModel.initialFilterSearchHis(),
  filterOffers: {
    url: '',
    title: '',
    offset: 0,
    page: 1,
  },
  filterCreative: {
    message: '',
    title: '',
    offset: 0,
    page: 1,
    sortBy: '',
    sortDirection: '',
  },
  filterNotification: {
    offset: 5,
    limit: 5,
  },
};

export default (state, actions) => {
  if (checkTypeValue(state, 'undefined')) {
    return initialState;
  }
  switch (actions.type) {
    case changeFilter(types.CHANGE_FILTER_NOTIFICATION):
      return {
        ...state,
        filterNotification: actions.filterNotification,
      };

    case setDefaultFilter(types.CHANGE_FILTER_NOTIFICATION):
      return {
        ...state,
        filterNotification: initialState.filterNotification,
      };

    case changeFilter(types.CHANGE_FILTER_CREATIVE):
      return {
        ...state,
        filterCreative: actions.filterCreative,
      };

    case setDefaultFilter(types.CHANGE_FILTER_CREATIVE):
      return {
        ...state,
        filterCreative: initialState.filterCreative,
      };

    case changeFilter(types.CHANGE_FILTER_OFFERS):
      return {
        ...state,
        filterOffers: actions.filterOffers,
      };

    case setDefaultFilter(types.CHANGE_FILTER_OFFERS):
      return {
        ...state,
        filterOffers: initialState.filterOffers,
      };

    case changeFilter(types.CHANGE_FILTER_CAMPAIGN):
      return {
        ...state,
        filterCampaign: actions.filterCampaign,
      };

    case setDefaultFilter(types.CHANGE_FILTER_CAMPAIGN):
      return {
        ...state,
        filterCampaign: initialState.filterCampaign,
      };

    default:
      return state;
  }
};
